import {ApiTags, baseApi} from "../../../app/api/baseApi";
import {CmQueryResult} from "../../../app/types";
import {AccessUser, MediumAccessPayload, MediumAssignment} from "../types";

export const accessManagementApiSlice = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAccessUsers: builder.query<AccessUser[], void>({
            query: () => {
                return {
                    reducerPath: 'accessUsers',
                    url: `/api/v1/users?page=1&items=200`,
                    method: 'GET',
                }
            },
            transformResponse: (response: CmQueryResult<AccessUser[]>) => {
                return response.data
            },
            keepUnusedDataFor: 120
        }),
        getMediumAccesses: builder.query<MediumAssignment[], void>({
            query: () => {
                return {
                    reducerPath: 'mediumAccesses',
                    url: `/api/v1/medium_accesses`,
                    method: 'GET',
                }
            },
            transformResponse: (response: CmQueryResult<MediumAssignment[]>) => {
                return response.data
            },
            providesTags: [ApiTags.MediumAccessesList]
        }),
        createMediumAccess: builder.mutation<MediumAssignment, MediumAccessPayload>({
            query: (body) => {
                return {
                    url: `/api/v1/medium_accesses`,
                    method: 'POST',
                    body,
                }
            },
            invalidatesTags: [ApiTags.MediumAccessesList]
        }),
        updateMediumAccess: builder.mutation<MediumAssignment, { id: number } & MediumAccessPayload>({
            query: ({id, ...body}) => {
                return {
                    url: `/api/v1/medium_accesses/${id}`,
                    method: 'PATCH',
                    body,
                }
            },
            invalidatesTags: [ApiTags.MediumAccessesList]
        }),
        deleteMediumAccess: builder.mutation<void, number>({
            query: (id) => {
                return {
                    url: `/api/v1/medium_accesses/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: [ApiTags.MediumAccessesList]
        }),
    })
})

export const {
    useGetAccessUsersQuery,
    useGetMediumAccessesQuery,
    useCreateMediumAccessMutation,
    useUpdateMediumAccessMutation,
    useDeleteMediumAccessMutation,
} = accessManagementApiSlice
